import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          newsletterTemplates ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              name,
              content,
              activated,
              created_at,
              updated_at
            }
          }
        }
      `
    })
  },
  add(template) {
    return axios.post('', {
      query: `
        mutation {
          createNewsletterTemplate ${paramsObjToGraphQLParams(template)} {
            id,
            name,
            content,
            activated,
            created_at,
            updated_at
          }
        }
      `
    })
  },
  update(template) {
    return axios.post('', {
      query: `
        mutation {
          updateNewsletterTemplate ${paramsObjToGraphQLParams(template)} {
            id,
            name,
            content,
            activated,
            created_at,
            updated_at
          }
        }
      `
    })
  },
  delete(templateId) {
    return axios.post('', {
      query: `
        mutation {
          deleteNewsletterTemplate (
            id: ${templateId}
          )
        }
      `
    })
  },
  infos(templateId) {
    return axios.post('', {
      query: `
        query {
          newsletterTemplateInfos (
            id: ${templateId}
          ) {
            id,
            name,
            content,
            activated,
            created_at,
            updated_at
          }
        }
      `
    })
  }
}
